// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kG0O","clinicsSelect":"styles_clinicsSelect__t_P0x"};